// extracted by mini-css-extract-plugin
export default {"root":"PlasmicPaymentRequestButton_root__eDkX1","text":"PlasmicPaymentRequestButton_text__gmduM"};